import { render, staticRenderFns } from "./AuthorizedRepsTable.vue?vue&type=template&id=6c09cf36&scoped=true"
import script from "./AuthorizedRepsTable.vue?vue&type=script&lang=js"
export * from "./AuthorizedRepsTable.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedRepsTable.vue?vue&type=style&index=0&id=6c09cf36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c09cf36",
  null
  
)

export default component.exports